import { RegimeScheduleTotalCaption } from "./regime-schedule-total-caption"
import { useListedRegimeScheduleTotal } from "./use-listed-regime-schedule-total"

export function ListRegimeScheduleTotal() {
    const total = useListedRegimeScheduleTotal()
    if (!total) return null
    return <RegimeScheduleTotalCaption total={total} focusable={false} />
}
